const STORAGE_KEY = 'plausible_ignore';
export const BIO_ANALYTICS_PREFERENCE_EVENT = 'owlscran:bio-analytics-preference';
let disabledForPage = false;

/** An opt-out preference, never a visitor identifier. Shared with Plausible. */
export function bioAnalyticsDisabled(): boolean {
  if (
    typeof navigator !== 'undefined' &&
    (navigator.doNotTrack === '1' ||
      (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl)
  )
    return true;
  if (disabledForPage) return true;
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function disableBioAnalytics(): void {
  try {
    localStorage.setItem(STORAGE_KEY, 'true');
  } catch {
    disabledForPage = true;
  }
  window.dispatchEvent(new Event(BIO_ANALYTICS_PREFERENCE_EVENT));
}
